module.exports = __webpack_public_path__ + "img/feature_buy_bonus_ph.a84e907c.png";